export default function (context, {field, value}) {
    let data = {};
    switch (field) {
        case 'Contragent':
            data.ContragentId = value.value;
            data.ContragentName = value.label;
        default:
            data[field] = value;
    }

    context.commit('set', data);
}